import { GridFilterModel, GridPaginationModel, GridSortModel } from '@mui/x-data-grid-premium';
import { isEmptyGridFilterValue } from '@parkchirp/ui-library';
import { Dispatch, SetStateAction } from 'react';

import { convertMuiFilterForV2Api } from '../../utils';

export const defaultFilters: any = [
	{
		propertyName: 'suspensionStatus',
		op: 'in',
		value: ['Active', 'Suspension_Pending'],
	},
	{
		propertyName: 'terminationStatus',
		op: 'in',
		value: ['Active', 'Termination_Pending'],
	},
];

export const OnSortModelChange =
	({
		setPaginationModel,
		setSortOrder,
	}: {
		setPaginationModel: Dispatch<SetStateAction<GridPaginationModel>>;
		setSortOrder: Dispatch<
			SetStateAction<{
				field: string;
				sort: string;
			}>
		>;
	}) =>
	(sortModel: GridSortModel) => {
		setPaginationModel((prev) => ({ ...prev, page: 0 }));
		if (!sortModel.length) {
			return setSortOrder({ field: 'createdAt', sort: 'DESC' });
		}

		const { field, sort } = sortModel[0];

		return setSortOrder({ field, sort });
	};

export const OnFilterModelChange =
	({
		setPaginationModel,
		setFilters,
	}: {
		setPaginationModel: Dispatch<SetStateAction<GridPaginationModel>>;
		setFilters: Dispatch<
			SetStateAction<
				{
					propertyName: string;
					op: string;
					value: string;
				}[]
			>
		>;
	}) =>
	(filterModel: GridFilterModel) => {
		setPaginationModel((prev) => ({ ...prev, page: 0 }));

		const { items: filterItems } = filterModel;

		if (!filterItems.length || filterItems.every((i) => !i.value)) {
			setFilters([]);
			return;
		}

		const queryFilters = filterItems
			.map((filter) => {
				const { field, operator, value } = filter;

				if (isEmptyGridFilterValue(value) && !['isEmpty', 'isNotEmpty'].includes(operator)) return [];

				const op = convertMuiFilterForV2Api(operator, value);

				return {
					propertyName: field,
					op: op.op,
					value: value ?? null,
				};
			})
			.flat();

		setFilters(queryFilters);
	};
